import React from 'react';
import FooterDesktop from '../../components/Footer/FooterDesktop/FooterDesktop';
import HeaderBig from '../../components/Header/Big/HeaderBig';
import styles from './Contact.module.css';
import ContactMain from './ContactMain/ContactMain';

const Contact = () => {
  return (
    <div className={styles.container}>
      <HeaderBig className={styles.header} />

      <main className={styles.main}>
        <ContactMain />

        <FooterDesktop />
      </main>
    </div>
  );
};

export default Contact;
